import React, { useEffect, useLayoutEffect, useRef, useState, useMemo } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { setGlobalLoader } from "../../../redux/slices/globalLoader";
import { useDispatch, useSelector } from "react-redux";
import GlobalLoader from "./globalLoader";
import { setUserType } from "../../../redux/slices/userType";
import Header from "./header";
import { getLocalKey, getUser, handleServerValidations, setLocalKey } from "../../../utils/commonfunction";
import {
    SWAL_SETTINGS,
    ATLEAST_ONE_CAPITAL_REGEX,
    ATLEAST_ONE_NUMBER_REGEX,
    ATLEAST_ONE_SPECIAL_CHARACTER_REGEX,
    PASSWORD_MIN_LENGTH,
    PASSWORD_MAX_LENGTH,
    ATLEAST_ONE_SMALL_REGEX, ROLE,
    SOCKET_EVENTS
} from "../../../utils/Constants";
import * as Yup from 'yup';
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import CustomError from "../../../utils/customError";
import { getRestaurantSettings, updateInitialPassword } from "../services/profile.services";
// import { SOCKET_CLIENT } from "../../../utils/socket";
import { addRestData } from "../../../redux/slices/restSettings";
// import { GlobalSettingsDetails } from '../../website/services/website.services';
import Sidebar from "../../../../src/modules/center/shared/sidebar";

const CenterLayout = () => {
    const passwordModalBtn = useRef();
    const passwordModalCloseBtn = useRef();
    const location = useLocation();
    const dispatch = useDispatch();
    const loaderState = useSelector((state) => state.globalLoader);
    const navigate = useNavigate();
    window.navigate_ = navigate;
    // const [show, setShow] = useState(true);
    const [restaurantDetailChanged, setRestaurantDetailChanged] = useState(false);
    const { t } = useTranslation();
    const [showNewPassword, setShowNewPassword] = useState("false");
    const [showConfirmPassword, setShowConfirmPassword] = useState("false");

    const [showAuthBox, setShowAuthBox] = useState(false);

    const handleShow = (field) => {
        if (field === "new_password") {
            // setShowNewPassword((prev) => !prev);
            setShowNewPassword(!showNewPassword);
        } else if (field === "confirm_password") {
            // setShowConfirmPassword((prev) => !prev);
            setShowConfirmPassword(!showConfirmPassword);
        }
    };

    useEffect(() => {
        const body = document.querySelector('body');
        if (body) {
            body.classList.add('restaurant_inner_body');
            if (getLocalKey("darktheme") === "true") {
                document.querySelector("html")?.classList.add("dark-theme");
            }
        }
    }, []);

    useLayoutEffect(() => {
        dispatch(setUserType("center"));
        Promise.all([
            import("../../../assets/center/css/style.css"),
        ]).then(() => {
            dispatch(setGlobalLoader(false));
        });
        // dispatch(setGlobalLoader(false));
    }, []);

    useEffect(() => {
        const userData = getUser(ROLE.CENTER);
        setTimeout(() => {
            if (userData.initial_password_changed === "true" || userData.initial_password_changed === true) {
                /** User changed his/her password already */
            } else {
                // passwordModalBtn?.current?.click();
                setShowAuthBox(true);
            }
        }, 100);
    }, [location]);

    // const handleShow = () => {
    //     setShow(!show);
    // };
    const validationSchema = Yup.object().shape({
        new_password: Yup.string()
            .required("center.change_password.label_new_password_error")
            .matches(
                ATLEAST_ONE_SMALL_REGEX,
                "center.change_password.password_validation_lowercase"
            )
            .matches(
                ATLEAST_ONE_CAPITAL_REGEX,
                "center.change_password.Password_Validation_uppercase"
            )
            .matches(
                ATLEAST_ONE_NUMBER_REGEX,
                "center.change_password.Password_Validation_number"
            )
            .matches(
                ATLEAST_ONE_SPECIAL_CHARACTER_REGEX,
                "center.change_password.Password_Validation_special_char"
            )
            .min(PASSWORD_MIN_LENGTH, "center.change_password.Password_Validation_minimum_length")
            .max(
                PASSWORD_MAX_LENGTH,
                "center.change_password.Password_Validation_maximum_length"
            ),
        confirm_password: Yup.string()
            .required("center.change_password.label_confirm_password_error")
            .oneOf([Yup.ref("new_password"), null], "center.change_password.password_validation_does_not_match"),
    });
    const changePasswordForm = useFormik({
        initialValues: {
            new_password: "",
            confirm_password: ""
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            updateInitialPassword(values).then((response) => {
                if (response.success) {
                    let userData = getUser(ROLE.CENTER);
                    userData.initial_password_changed = true;
                    setLocalKey(ROLE.CENTER, JSON.stringify(userData));
                    Swal.fire({
                        icon: "success",
                        text: response.message,
                        ...SWAL_SETTINGS,
                    });
                    // passwordModalCloseBtn?.current?.click();  
                    setShowAuthBox(false);
                } else {
                    Swal.fire({
                        icon: "error",
                        text: handleServerValidations(response),
                        ...SWAL_SETTINGS,
                    });
                }
            }).catch((error) => {
                console.log("error===>", error)
            });
        }
    });

    /** Joining user to socket for realtime notifications >>>>> */
    // useMemo(() => {
    //     const user = getUser(ROLE.CENTER);
    //     if (user) {
    //         let joinRequest = {
    //             roomID: user._id
    //         };
    //         SOCKET_CLIENT.emit('JOIN-USER', joinRequest, (error) => {
    //             if (error) {
    //                 console.log("*****Socket connection error on JOIN-USER", error);
    //             }
    //         });
    //     }
    // }, [location]);
    /** Joining user to socket for realtime notifications <<<<< */
    // useMemo(() => {
    //     SOCKET_CLIENT.on('GET-DATA', async (response) => {
    //         if (response) {
    //             if (response?.event === SOCKET_EVENTS.RESTAURANT_DETAILS_CHANGED) {
    //                 console.log("socket event listened")
    //                 setRestaurantDetailChanged(!restaurantDetailChanged)
    //             }
    //         }
    //     });
    // }, [restaurantDetailChanged]);



    // useMemo(() => {
    //     getRestaurantSettings().then((globalDetails) => {
    //         dispatch(addRestData(globalDetails?.data));
    //         setRestaurantDetailChanged(false);
    //         let r = document.querySelector(':root');
            
    //         /** Light theme colors */
    //         r.style.setProperty('--primary-tl', globalDetails?.data?.light_theme_colors?.primary_color || "");
    //         r.style.setProperty('--body-bg-tl', globalDetails?.data?.light_theme_colors?.background_color || "");
    //         r.style.setProperty('--header-bg-tl', globalDetails?.data?.light_theme_colors?.header_color_background || "");
    //         r.style.setProperty('--header-icons-tl', globalDetails?.data?.light_theme_colors?.header_color_icon || "")
    //         r.style.setProperty('--header-text-tl', globalDetails?.data?.light_theme_colors?.header_color_text || "")
    //         r.style.setProperty('--sidebar-bg-tl', globalDetails?.data?.light_theme_colors?.sidebar_color_background || "");
    //         r.style.setProperty('--sidebar-icons-tl', globalDetails?.data?.light_theme_colors?.sidebar_color_icon || "");
    //         r.style.setProperty('--sidebar-text-tl', globalDetails?.data?.light_theme_colors?.sidebar_color_text || "");

    //         /** Dark theme colors */
    //         r.style.setProperty('--primary-dt', globalDetails?.data?.dark_theme_colors?.primary_color || "");
    //         r.style.setProperty('--body-bg-dt', globalDetails?.data?.dark_theme_colors?.background_color || "");
    //         r.style.setProperty('--header-bg-dt', globalDetails?.data?.dark_theme_colors?.header_color_background || "");
    //         r.style.setProperty('--header-icons-dt', globalDetails?.data?.dark_theme_colors?.header_color_icon || "")
    //         r.style.setProperty('--header-text-dt', globalDetails?.data?.dark_theme_colors?.header_color_text || "")
    //         r.style.setProperty('--sidebar-bg-dt', globalDetails?.data?.dark_theme_colors?.sidebar_color_background || "");
    //         r.style.setProperty('--sidebar-icons-dt', globalDetails?.data?.dark_theme_colors?.sidebar_color_icon || "");
    //         r.style.setProperty('--sidebar-text-dt', globalDetails?.data?.dark_theme_colors?.sidebar_color_text || "");
    //     });
    // }, [restaurantDetailChanged]);

    return (
        <>
            {loaderState ? (
                <GlobalLoader />
            ) : (
                <div>
                    <Header />
                    <Sidebar />
                    <Outlet />
                    {/* {showAuthBox && (
                        <div className="auth-body d-flex align-items-center justify-content-center">
                                <div className="auth-box">
                                    <div className="form-box-inner d-flex flex-column gap-5">
                                        <div className="form-logo">
                                            <svg viewBox="0 0 478 255" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M126.3 43.0998C133.8 43.2998 140 49.3998 140.1 57.4998C140.25 70.2545 140.231 83.0092 140.212 95.7217C140.206 99.953 140.2 104.18 140.2 108.4C140.2 113.929 140.211 119.47 140.222 125.015C140.244 136.115 140.266 147.229 140.2 158.3C140.1 165.3 135.6 170.8 129.5 172.3C123.4 173.8 116.9 171.4 114.2 165.8C112.7 162.6 112.1 158.7 112.1 155.2C111.95 131.801 111.968 108.347 111.987 84.878C111.993 77.053 112 69.2264 112 61.3998C112 59.8998 112 58.3998 112.1 56.8998C112.8 48.5998 118.6 42.8998 126.3 43.0998ZM95.3998 106.8C90.4998 93.2996 80.3998 85.3996 66.9998 81.7996C45.9998 76.2996 26.8998 79.3996 11.3998 95.6996C-0.300156 108.1 -1.30016 123.5 1.09984 139.3C3.79984 157.1 18.7998 171.4 36.5998 173.7C49.8998 175.4 61.2998 171.8 70.4998 159.9C71.9998 167 74.8998 171.3 81.0998 172.5C89.7998 174.2 97.4998 168.4 97.6998 159C97.963 145.84 97.6875 132.68 97.4133 119.588L97.4129 119.57C97.3747 117.745 97.3365 115.922 97.2999 114.1C97.0999 111.6 96.2999 109.1 95.3998 106.8ZM52.5998 149.8C35.0998 151.9 24.4998 138.8 28.6998 120.3C31.9998 105.8 47.6998 98.7996 60.7998 106.1C65.3998 108.7 68.1999 112.7 68.8998 118C69.2198 120.24 69.2839 122.48 69.3479 124.72C69.3639 125.28 69.3799 125.84 69.3998 126.4C69.3998 141.2 64.1998 148.4 52.5998 149.8ZM321.5 80.8997C315.5 82.8997 312.1 87.8997 312 95.1997C311.9 107.7 311.9 120.2 311.9 132.7C311.9 137.3 310.8 141.4 306.9 144.1C300.5 148.5 293.4 148.9 286.4 146C280.1 143.4 279.1 137.5 279.1 131.3C279.1 128.175 279.106 125.05 279.113 121.925C279.131 112.55 279.15 103.175 279 93.7997C278.9 86.0997 273.2 80.4997 265.8 80.0997C258.5 79.6997 251.5 84.8997 251.3 92.2997C251.247 94.4921 251.187 96.688 251.128 98.8863L251.128 98.8888C250.734 113.334 250.338 127.88 251.9 142.2C254.3 165.2 275.6 177.5 297.5 169.8C301.21 168.47 304.577 166.307 308.013 164.099C309.485 163.154 310.97 162.2 312.5 161.3C314 177.2 305.5 186.9 289.5 186.5C285.676 186.431 281.898 185.57 278.136 184.713C276.388 184.314 274.644 183.917 272.9 183.6C265.2 182.1 259 185.2 257.1 191.4C255.2 197.7 258 203.4 265.3 206.5C277.2 211.5 289.6 211.8 302.1 209.6C322.5 206.1 339 189.2 339.9 168.7C340.9 143.6 340.5 118.4 340.1 93.1997C340 83.7997 330.4 77.8997 321.5 80.8997ZM410.7 79.4999C425.8 80.3999 437.1 89.8999 440.1 104.8C441 109.3 441.3 114 441.5 118.7C441.699 131.365 441.6 143.932 441.501 156.597L441.5 156.7C441.4 166.8 435.7 172.9 427 172.8C418.7 172.6 413.3 166.3 413.2 156.4C413.133 148.13 413.155 139.904 413.178 131.693C413.189 127.593 413.2 123.496 413.2 119.4C413.2 113.4 412.2 107.6 406 105.3C398.8 102.6 390.8 102.2 385 108.1C382.4 110.8 381.2 115.8 381 119.8C380.636 128.164 380.696 136.527 380.755 144.891C380.777 148.027 380.8 151.164 380.8 154.3C380.8 156.3 380.8 158.3 380.5 160.3C379.4 168.2 373.4 173.2 365.7 172.8C358.6 172.4 352.6 166.5 352.4 159C352.185 152.711 352.226 146.372 352.267 140.054V140.053V140.052L352.267 140.042C352.283 137.523 352.3 135.007 352.3 132.5C352.3 128.526 352.289 124.563 352.277 120.607C352.255 112.718 352.233 104.859 352.3 96.9999C352.3 88.4999 355.8 83.5999 362.9 81.4999C369.4 79.5999 374 81.9999 378.7 89.3999C378.766 89.5333 378.966 89.6666 379.3 89.8889L379.301 89.8896C379.467 90.0005 379.667 90.1336 379.9 90.2999C388.7 82.1999 399 78.7999 410.7 79.4999ZM233.4 82.3C225.1 78.6 216.3 82.1 212.8 90.5C212 92.5001 211.225 94.5252 210.45 96.5504L210.449 96.553C209.674 98.577 208.9 100.601 208.1 102.6C206.15 107.6 204.175 112.599 202.201 117.599C200.225 122.599 198.25 127.6 196.3 132.6C196.1 132.55 195.9 132.525 195.7 132.5C195.5 132.475 195.3 132.45 195.1 132.4C194.8 131.65 194.475 130.9 194.15 130.15C193.825 129.4 193.5 128.65 193.2 127.9C191.132 122.73 189.099 117.544 187.064 112.354L187.063 112.352C184.178 104.994 181.291 97.6298 178.3 90.3C175 82.1 166.8 78.8 158.6 82C151.4 84.8 148.9 91.9 152 100.4C152.3 101.3 152.7 102.3 153.1 103.2C157.849 113.197 162.622 123.169 167.396 133.141L167.4 133.15C172.175 143.125 176.95 153.1 181.7 163.1C184.6 169.1 188.7 173.3 195.8 173.3C202.7 173.3 206.6 168.9 209.4 163.2C219.3 142.7 229.2 122.1 239 101.5C242.8 93.6 240.3 85.3 233.4 82.3Z" fill="var(--black)" />
                                                <path d="M464.8 145.7C457.1 145.7 451.5 151.1 451.4 158.7C451.3 166.8 456.5 172.5 464.3 172.7C472.1 172.9 477.9 167.3 478 159.5C478.1 151.5 472.5 145.7 464.8 145.7Z" fill="var(--primary)" />
                                                <path d="M386.1 0H54.0996C47.7996 0 42.5996 5.2 42.5996 11.5V66.3H49.5996V11.5C49.5996 9 51.5996 7 54.0996 7H386.1C388.6 7 390.6 9 390.6 11.5V66.3H397.6V11.5C397.6 5.2 392.4 0 386.1 0ZM390.6 186.6V243.5C390.6 246 388.6 248 386.1 248H54.0996C51.5996 248 49.5996 246 49.5996 243.5V186.6H42.5996V243.5C42.5996 249.8 47.7996 255 54.0996 255H386.1C392.4 255 397.6 249.8 397.6 243.5V186.6H390.6Z" fill="var(--primary)" />
                                            </svg>
                                        </div>
                                        <div className="form-card">
                                            <div className="form-text">
                                                <h5 className="mt-2">{t("center.change_password.change_password")}</h5>
                                                <p>{t("center.change_password.restaurant_force_change_password_note")}</p>
                                            </div>
                                            <form onSubmit={changePasswordForm.handleSubmit}>
                                                <div className="form-group mb-3">
                                                    <label htmlFor="new_password" className="form-label">{t('center.change_password.label_password')} <span>*</span></label>
                                                    <div className="input-group">
                                                        <input
                                                            type={!showNewPassword ? "text" : "password"}
                                                            id="new_password"
                                                            name="new_password"
                                                            className="form-control border-end-0"
                                                            placeholder={t("center.reset_password.placeholder_new_password")}
                                                            value={changePasswordForm.values.new_password}
                                                            onChange={changePasswordForm.handleChange}
                                                            onBlur={changePasswordForm.handleBlur}
                                                        />
                                                        <span className="input-group-text cp restaurant-password-toggle"  onClick={() => handleShow("new_password")}
                                                        >
                                                           {showNewPassword ? <i className="ti ti-eye-off"></i> : <i className="ti ti-eye"></i>}
                    
                                                        </span>
                                                    </div>
                                                    <CustomError name="new_password" form={changePasswordForm} className="text-danger" />
                                                </div>
                                                <div className="form-group mb-3">
                                                    <label htmlFor="confirm_password" className="form-label">{t("center.change_password.label_confirm_password")}<span>*</span></label>
                                                    <div className="input-group">
                                                        <input
                                                            type={!showConfirmPassword ? "text" : "password"}
                                                            id="confirm_password"
                                                            name="confirm_password"
                                                            className="form-control border-end-0"
                                                            placeholder={t("center.change_password.placeholder_confirm_password")}
                                                            value={changePasswordForm.values.confirm_password}
                                                            onChange={changePasswordForm.handleChange}
                                                            onBlur={changePasswordForm.handleBlur}
                                                        />
                                                        <span className="input-group-text cp restaurant-password-toggle" onClick={() => { handleShow("confirm_password"); }}
                                                        >
                                                            {showConfirmPassword ? <i className="ti ti-eye-off"></i> : <i className="ti ti-eye"></i>}
                                                        </span>
                                                    </div>
                                                    <CustomError name="confirm_password" form={changePasswordForm} className="text-danger" />
                                                </div>
                                                <button type="submit" className={"btn btn-primary w-100"}>
                                                    {t("center.reset_password.btn_submit")}
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    )} */}
                </div>
            )}
        </>
    );
};
export default CenterLayout;
